import { render, staticRenderFns } from "./ShippingMessageThreadForm.vue?vue&type=template&id=5c5bcf06"
import script from "./ShippingMessageThreadForm.vue?vue&type=script&lang=js"
export * from "./ShippingMessageThreadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports